import React from "react";
import PropTypes from "prop-types";
import ContentLoader from "react-content-loader";

const SkeletonCard = ({ borderRadius }) => {
  return (
    <ContentLoader
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
      }}
    >
      <rect
        x="0"
        y="0"
        rx={borderRadius}
        ry={borderRadius}
        width="100%"
        height="100%"
      />
    </ContentLoader>
  );
};

SkeletonCard.propTypes = { borderRadius: PropTypes.number };

SkeletonCard.defaultProps = { borderRadius: 0 };

export default SkeletonCard;
